/* eslint frontbucket-patterns/no-new-sagas: "warn" */
import { put, take, select } from 'redux-saga/effects';

import { LoadRepositoryPage } from 'src/sections/repository/actions';
import fetchUserEmails from 'src/sections/repository/actions/fetch-user-emails';
import { getIsRepositoryPageLoadingErrorGuardEnabled } from 'src/selectors/feature-selectors';

export function* loadRepositoryErrorSaga() {
  const isRepositoryPageLoadingErrorGuardEnabled = select(
    getIsRepositoryPageLoadingErrorGuardEnabled
  );

  if (isRepositoryPageLoadingErrorGuardEnabled) {
    while (true) {
      yield take(LoadRepositoryPage.ERROR);
      yield put(fetchUserEmails());
    }
  }
}
